import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanDeactivateGuardService } from "src/app/core/can-deactivate-guard.service";

import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { NotasCadastroComponent } from "./cadastro/notas-cadastro.component";
import { NotasPesquisaComponent } from "./pesquisa/notas-pesquisa.component";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";

const routes:Routes = [
    {
        path: 'notas/pesquisa',
        component: NotasPesquisaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        }, 
        data: { canReuse: false }
    },{
        path: 'notas/:id',
        component: NotasCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
    },{
        path: 'notas',
        component: NotasCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
    },
];

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule],
})

export class NotasRoutingModule{}